import { render, staticRenderFns } from "./TooltipEx.vue?vue&type=template&id=21e465f1&scoped=true"
import script from "./TooltipEx.vue?vue&type=script&lang=js"
export * from "./TooltipEx.vue?vue&type=script&lang=js"
import style0 from "./TooltipEx.vue?vue&type=style&index=0&id=21e465f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e465f1",
  null
  
)

export default component.exports